import React, { useEffect, useState } from 'react';
import '../../styles/Contact.css';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaClock, FaCalendarAlt, FaClipboardList } from 'react-icons/fa';
import { ContactT, currentLanguage } from '../../services/LanguageTranslationService';
import holidays from '../../assets/documents/holidays.pdf';
const Contact = () => {
  const [language, setLanguage] = useState('');
  useEffect(() => {
    const lang = currentLanguage;
    setLanguage(lang);
 
  }, []);

  return (
    <section className="contact-section">
      <div className="contact-header">
        <h2>{ContactT('contact.title')}</h2>
        <div className="header-underline"></div>
      </div>

      <div className="contact-grid">
        {/* Akurdi Office */}
        <div className="contact-card">
          <div className="card-header">
            <FaMapMarkerAlt className="card-icon" />
            <h3>{ContactT('contact.akurdiOffice.title')}</h3>
          </div>

          <div className="contact-info-map">
            <iframe
              title="Akurdi Office Location"
              // src={
              //   currentLanguage === 'en'
              //     ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.0875875474458!2d73.87078087496307!3d18.5249436825695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c05be63bb9cd%3A0xd50a6017ed9ea79b!2sCentral%20Building!5e0!3m2!1sen!2sin!4v1745348788349!5m2!1sen!2sin"
              //     : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.087587161806!2d73.8733558!3d18.5249437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c05be63bb9cd%3A0xd50a6017ed9ea79b!2z4KSu4KWB4KSW4KWN4KSvIOCkh-CkruCkvuCksOCkpCwg4KSq4KWB4KSj4KWH!5e0!3m2!1smr!2sin!4v1745484035647!5m2!1smr!2sin"
              // }

              src={
                currentLanguage === 'en'
                  ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.313884814733!2d74.565248!3d16.860360399999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc11840c8545b77%3A0x861d950f6a40370b!2sSangli%20Miraj%20Kupwad%20Corporation%20Administrtive%20Building!5e0!3m2!1sen!2sin!4v1769963730816!5m2!1sen!2sin"
                  : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.313884814733!2d74.565248!3d16.860360399999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc11840c8545b77%3A0x861d950f6a40370b!2sSangli%20Miraj%20Kupwad%20Corporation%20Administrtive%20Building!5e0!3m2!1sen!2sin!4v1769963730816!5m2!1sen!2sin"
              }

             // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.0875875474458!2d73.87078087496307!3d18.5249436825695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c05be63bb9cd%3A0xd50a6017ed9ea79b!2sCentral%20Building!5e0!3m2!1sen!2sin!4v1745348788349!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '10px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

        </div>




        {/* Administrative Office */}
        <div className="contact-card">
          <div className="card-header">
            <FaMapMarkerAlt className="card-icon" />
            <h3>{ContactT('contact.adminOffice.title')}</h3>
          </div>
          <div className="contact-info">
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h4>{ContactT('contact.address')}</h4>
                <p>
                  {ContactT('contact.adminOffice.address.line1')}<br />
                  {ContactT('contact.adminOffice.address.line2')}<br />
                  {ContactT('contact.adminOffice.address.line3')}
                </p>
              </div>
            </div>
            <div className="info-item">
              <FaEnvelope className="info-icon" />
              <div>
                <h4>{ContactT('contact.email')}</h4>
                <p>smkctp201@gmail.com</p>
              </div>
            </div>
            {/* <div className="info-item">
              <FaPhone className="info-icon" />
              <div>
                <h4>{ContactT('contact.phone')}</h4>
                <p>020-26122076</p>
              </div>
            </div> */}
          </div>
        </div>

        {/* Other Details */}
        <div className="contact-card">
          <div className="card-header">
            <FaPhone className="card-icon" />
            <h3>{ContactT('contact.otherDetails.title')}</h3>
          </div>
          <div className="contact-info">
            <div className="info-item">
              <FaPhone className="info-icon" />
              <div>
                <h4>{ContactT('contact.otherDetails.telephone')}</h4>
                <p>{ContactT('contact.otherDetails.telephoneText')}</p>
              </div>
            </div>
            <div className="info-item">
              <FaClock className="info-icon" />
              <div>
                <h4>{ContactT('contact.otherDetails.hours')}</h4>
                <p>{ContactT('contact.otherDetails.hoursText')}</p>
              </div>
            </div>

            <div className="info-item">
              <FaCalendarAlt className="info-icon" />
              <div>
                <h4>{ContactT('contact.otherDetails.weeklyOff')}</h4>
                <p>{ContactT('contact.otherDetails.weeklyOffText')}</p>
              </div>
            </div>

            <div className="info-item">
              <FaClipboardList className="info-icon" />
              <div>
                <h4>{ContactT('contact.otherDetails.publicHolidays')}</h4>
                <a href={holidays}><p>{ContactT('contact.otherDetails.publicHolidaysDownload')}</p></a>
              </div>
            </div>


          </div>
        </div>
      </div>

      {/* <div className="contact-table-section">
        <div className="section-header">
          <h3>{ContactT('contact.directory.title')}</h3>
          <div className="header-underline"></div>
        </div>
        <div className="table-responsive">
          <table className="contact-table">
            <thead>
              <tr>
                <th>{ContactT('contact.directory.srNo')}</th>
                <th>{ContactT('contact.directory.officerName')}</th>
                <th>{ContactT('contact.directory.divison')}</th>
                <th>{ContactT('contact.directory.department')}</th>
                <th>{ContactT('contact.directory.phone')}</th>
                <th>{ContactT('contact.directory.email')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{ContactT('contact.directory.officers.officer1.name')}</td>
                <td>{ContactT('contact.directory.officers.officer1.division')}</td>
                <td>{ContactT('contact.directory.officers.officer1.department')}</td>
                <td>{ContactT('contact.directory.officers.officer1.phone')}</td>
                <td>{ContactT('contact.directory.officers.officer1.email')}</td>
              </tr>
              <tr>
                <td>2</td>
                <td>{ContactT('contact.directory.officers.officer2.name')}</td>
                <td>{ContactT('contact.directory.officers.officer2.division')}</td>
                <td>{ContactT('contact.directory.officers.officer2.department')}</td>
                <td>{ContactT('contact.directory.officers.officer2.phone')}</td>
                <td>{ContactT('contact.directory.officers.officer2.email')}</td>
              </tr>
              <tr>
                <td>3</td>
                <td>{ContactT('contact.directory.officers.officer3.name')}</td>
                <td>{ContactT('contact.directory.officers.officer3.division')}</td>
                <td>{ContactT('contact.directory.officers.officer3.department')}</td>
                <td>{ContactT('contact.directory.officers.officer3.phone')}</td>
                <td>{ContactT('contact.directory.officers.officer3.email')}</td>
              </tr>
              <tr>
                <td>4</td>
                <td>{ContactT('contact.directory.officers.officer4.name')}</td>
                <td>{ContactT('contact.directory.officers.officer4.division')}</td>
                <td>{ContactT('contact.directory.officers.officer4.department')}</td>
                <td>{ContactT('contact.directory.officers.officer4.phone')}</td>
                <td>{ContactT('contact.directory.officers.officer4.email')}</td>
              </tr>
              <tr>
                <td>5</td>
                <td>{ContactT('contact.directory.officers.officer5.name')}</td>
                <td>{ContactT('contact.directory.officers.officer5.division')}</td>
                <td>{ContactT('contact.directory.officers.officer5.department')}</td>
                <td>{ContactT('contact.directory.officers.officer5.phone')}</td>
                <td>{ContactT('contact.directory.officers.officer5.email')}</td>
              </tr>
              <tr>
                <td>6</td>
                <td>{ContactT('contact.directory.officers.officer6.name')}</td>
                <td>{ContactT('contact.directory.officers.officer6.division')}</td>
                <td>{ContactT('contact.directory.officers.officer6.department')}</td>
                <td>{ContactT('contact.directory.officers.officer6.phone')}</td>
                <td>{ContactT('contact.directory.officers.officer6.email')}</td>
              </tr>
              <tr>
                <td>7</td>
                <td>{ContactT('contact.directory.officers.officer7.name')}</td>
                <td>{ContactT('contact.directory.officers.officer7.division')}</td>
                <td>{ContactT('contact.directory.officers.officer7.department')}</td>
                <td>{ContactT('contact.directory.officers.officer7.phone')}</td>
                <td>{ContactT('contact.directory.officers.officer7.email')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> */}
    </section>
  );
};

export default Contact;